<footer class="govbook-footer">
	<div class="govbook-footer__pre-footer">
		<div class="govbook-container">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<ul class="menu menu--footer">
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://langtons-house.vercel.app/house-gardens.html"
								>House and gardens</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://langtons-house.vercel.app/marriages-civil-partnerships.html"
								>Marriages and civil partnerships</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://langtons-house.vercel.app/marriages-civil-partnerships.html#venues"
								>Approved venues for ceremonies</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://langtons-house.vercel.app/fees-charges.html"
								>Fees and charges</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://langtons-house.vercel.app/marriages-civil-partnerships.html#legal"
								>Give notice of your marriage or civil partnership</a
							>
						</li>
					</ul>
				</div>

				<div class="col-sm-12 col-md-6">

          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://langtons-house.vercel.app/contact.html">Contact Langtons House</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.havering.gov.uk/cookies">Cookies</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.havering.gov.uk/council-data-spending/data-protection">Privacy notice</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
            </li>
          </ul>
					<h4>Email us</h4>
					<a href="mailto:ceremonies&#64;havering.gov.uk" class="footer-links"
						>ceremonies&#64;havering.gov.uk</a
					>
					<span>&nbsp;or call <a href="tel:01708433155" class="footer-links">01708 433 155</a></span>
					<nav
						aria-labelledby="block-ecc-theme-gov-socialmedia-menu"
						id="block-ecc-theme-gov-socialmedia"
						class="block block-menu navigation navigation--social-media"
					>
						<h2
							class="visually-hidden"
							id="block-ecc-theme-gov-socialmedia-menu"
						>
							Social Media
						</h2>

						<ul
							class="menu menu--social-media justify-content-end justify-content-md-start mt-3"
						>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Instagram (opens in new window)"
									class="footer-links"
									href="https://www.instagram.com/langtonshouse/"
									class="social-link instagram"
									>Instagram</a
								>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>

	<div class="govbook-footer__footer">
		<div class="govbook-container">
			<div class="govbook-row">
				<div class="govbook-row__full">
					<div
						class="govbook-region govbook-region--footer region region-footer"
					>
						<div class="padding-horizontal">
							<div class="govbook-region__inner govbook-region__inner--footer">
								<div
									id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
									class="block block-localgov-core block-localgov-powered-by-block"
								>
									<span
										>Powered by
										<a
											target="_blank"
											aria-label="Bookinglab | GovBook (opens in new window)"
											class="footer-links"
											href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=ecc
                                            "
											>bookinglab | GovBook</a
										></span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
